import doc                  from 'decorators/doc';
import model                from 'decorators/model';
import SalesPrivateApiModel from 'modelx/models/abstracts/SalesPrivateApiModel';
import { Rights }           from 'tools/Rights';

@model.cacheDuration()
@model.staticLabel('Statut')
@model.urnResource('quotation_status')
@doc.path('/quotation_statuses/{?id}')
export default class QuotationStatusModel extends SalesPrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'reference': SalesQuotationStatusReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'position': string;
	}> = {};

	@doc.string declare label: string;
	@doc.number declare position: number;
	@doc.string declare reference: SalesQuotationStatusReference;

	public get color() {
		switch (this.reference) {
			case 'blocked':
			case 'suspended':
				return '#ff0000';
			case 'activated':
				return '#008000';
			default:
				return '#808080';
		}
	}

	public get isUpdatable() {
		return Rights.quotation.isUpdatable(this);
	}

	public get isEventsAreUpdatable() {
		return Rights.quotation.eventsAreUpdatable(this);
	}
}
